import { __decorate } from "tslib";
import { NgModule } from '@angular/core';
import { AngularFireAuth } from './auth';
import 'firebase/auth';
var AngularFireAuthModule = /*@__PURE__*/ (function () {
    function AngularFireAuthModule() {
    }
    return AngularFireAuthModule;
}());
export { AngularFireAuthModule };
//# sourceMappingURL=auth.module.js.map
